import { Button, Flex, Menu, Text } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import React from 'react';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';

interface InvestmentDetailsMenuProps {
	onRevoke: () => void;
	openTargetDatesMenu: () => void;
	onViewHistory: () => void;
	canRevoke: boolean;
	canSetTargetDates: boolean;
}

export const InvestmentDetailsMenu = ({
	onRevoke,
	openTargetDatesMenu,
	onViewHistory,
	canRevoke,
	canSetTargetDates,
}: InvestmentDetailsMenuProps) => {
	const tMipManage = useTranslationMipManage();

	return (
		<Menu width={240} shadow="md" position="bottom-end" withinPortal>
			<Menu.Target>
				<Button variant="default">
					<Icon variant="more-v3" size="vlg" />
				</Button>
			</Menu.Target>

			<Menu.Dropdown
				sx={(theme) => ({
					boxShadow: '0px 16px 32px 0px #DCDFE0',
					borderColor: theme.colors.gray[0],
				})}
			>
				<Flex gap="0.25rem" direction="column">
					<Menu.Item onClick={onRevoke} disabled={!canRevoke}>
						<Flex gap="0.5rem" align="center" style={{ padding: '0.5rem' }}>
							<Icon variant="circle-cross" size="lg" />

							<Text size="sm">{tMipManage('investment_details.menu.revoke')}</Text>
						</Flex>
					</Menu.Item>

					<Menu.Item onClick={openTargetDatesMenu} disabled={!canSetTargetDates}>
						<Flex gap="0.5rem" align="center" style={{ padding: '0.5rem' }}>
							<Icon variant="calendar-notified" size="lg" />

							<Text size="sm">
								{tMipManage('investment_details.menu.target_dates')}
							</Text>
						</Flex>
					</Menu.Item>

					<Menu.Item onClick={onViewHistory}>
						<Flex gap="0.5rem" align="center" style={{ padding: '0.5rem' }}>
							<Icon variant="clock" size="lg" />

							<Text size="sm">
								{tMipManage('investment_details.menu.view_history', {
									defaultValue: 'View history',
								})}
							</Text>
						</Flex>
					</Menu.Item>
				</Flex>
			</Menu.Dropdown>
		</Menu>
	);
};
